import React from 'react'
import ListCousre from '../../Components/admin/ListCousre'
function Listcourse() {
  return (
    <div>
      <ListCousre/>
    </div>
  )
}

export default Listcourse
